var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.carusel
  }, [!_vm.isBotSigned ? _c('telegram-information-panel') : _vm._e(), _c('widget-information-panel'), _c('report-information-panel')], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }